export default "__VITE_ASSET__DTbhpNjc__"